import { origin, protocol } from '@web/utilities/window';
/**
 * Takes a protocol-relative URL or partial target.com URL and ensures it has the
 * current window protocol or HTTPS by default.
 *
 * @param url A protocol-relative URL, e.g. `//www.target.com`
 */
const makeAbsoluteProtocolUrl = (url) => {
    if (url.startsWith('//')) {
        return `${protocol() || 'https:'}${url}`;
    }
    return url;
};
/**
 * To parse the string and return the new native URL object
 *
 * @param url
 */
export const parseURL = (url) => {
    // prepend target.com to relative URLs
    if ((url[0] === '/' && url[1] === undefined) || (url[0] === '/' && url[1] !== '/')) {
        return new URL(`https://www.target.com${url}`);
    }
    if (url.startsWith('target.com')) {
        return new URL(`https://www.${url}`);
    }
    if (url.startsWith('www.target.com')) {
        return new URL(`https://${url}`);
    }
    try {
        /* Pass in document origin as base, which is ignored for absolute URLs but
           must be passed in for relative URLs */
        return new URL(makeAbsoluteProtocolUrl(url), origin() || undefined);
    }
    catch (error) {
        throw new Error(`${error.message}: ${url}`);
    }
};
